import { CompanyData, ContactData, PricingData } from "../type/PricingData";
import api from "./axios";

export const fetchPricing = async (): Promise<PricingData[]> => {
  const [oneTimeResponse, subscriptionResponse] = await Promise.all([
    api.get<PricingData[]>("/api/packages?purchase_type=one_time"),
    api.get<PricingData[]>("/api/packages?purchase_type=subscription"),
  ]);

  return [...oneTimeResponse.data, ...subscriptionResponse.data].map(
    (plan: PricingData) => ({
      ...plan,
      features: (plan.features ?? []).map((feature, index) =>
        typeof feature === "string"
          ? { id: index + 1, name: feature, package_name: plan.name }
          : feature,
      ),
      discounts: plan.discounts ?? [],
      trial_package: Boolean(plan.trial_package),
    }),
  );
};

export const fetchCompany = async (): Promise<CompanyData> => {
  const response = await api.get<CompanyData>("/api/company-info");
  return response.data;
};

export const postContactUs = async (contactData: ContactData): Promise<any> => {
  const response = await api.post("/api/contact-us", contactData);
  return response.data;
};

export const fetchEventCode = async (eventCode: string): Promise<any> => {
  const response = await api.get<string>(`/api/event/invitees/${eventCode}`);
  return response;
};
